export enum AuthErrorResponseCode {
  USER_CANCEL = 'user_cancel',
  INVALID_REQUEST = 'invalid_request',
  ACCESS_DENIED = 'access_denied',
  TIMEOUT = 'timeout',
  SERVER_ERROR = 'server_error',
  FORBIDDEN_ID_COUNTRY = 'forbidden_id_country',
  FAILURE_GENERAL = 'failure_general',
}

export const AuthErrorResponseCodeToDescriptionMap: Record<AuthErrorResponseCode, string> = {
  [AuthErrorResponseCode.USER_CANCEL]: 'User canceled authentication',
  [AuthErrorResponseCode.INVALID_REQUEST]: 'Request_uri invalid or expired',
  [AuthErrorResponseCode.ACCESS_DENIED]: 'User refused or failed authentication',
  [AuthErrorResponseCode.TIMEOUT]: 'Authentication timed out',
  [AuthErrorResponseCode.SERVER_ERROR]: 'Internal server error',
  [AuthErrorResponseCode.FORBIDDEN_ID_COUNTRY]: "This country token isn't accepted by the service provider.",
  [AuthErrorResponseCode.FAILURE_GENERAL]: 'Authentication failed',
};
